export const PLATFORMS = Object.freeze({
  IN: "IN",
  LK: "LK",
});

export const TARGET_ENVIRONMENTS = Object.freeze({
  DEVELOP: "dev",
  PRODUCTION: "prod",
});

export const OTHER_COUNTRY_CODE = "ZZ";

export const MAXIMUM_AGE_LIMIT = 60;

export const PRICING_TIERS = Object.freeze({
  "1M": "1m",
  "2M": "2m",
  "3M": "3m",
  "1M_BASIC": "1m_basic",
  "2M_BASIC": "2m_basic",
  "3M_BASIC": "3m_basic",
  "3M_PRO": "3m_pro",
  "6M_VIP": "6m_vip",
});

export const PRIMARY_TIME_ZONES = Object.freeze({
  UTC: "UTC",
  ASIA_COLOMBO: "Asia/Colombo",
  AUSTRALIA_MELBOURNE: "Australia/Melbourne",
});

export const ID_VERIFICATION_TYPES = Object.freeze({
  NIC: "NIC",
  PASSPORT: "PASSPORT",
  DRIVING_LICENCE: "DRIVING_LICENCE",
  OTHER: "OTHER",
});

export const CREATE_FLOW_VERSIONS = Object.freeze({
  v1: "v1",
  v2: "v2",
});

export const PARENT_TYPES = Object.freeze({
  MOTHER: "MOTHER",
  FATHER: "FATHER",
});

export const DRINKING_PREFERENCES = [
  { value: "YES", label: "Yes", label_si: "ඔව්" },
  { value: "NO", label: "No", label_si: "නැත" },
  { value: "OCCASIONAL", label: "Occasionally", label_si: "ඇතැම් විට" },
];

export const SMOKING_PREFERENCES = [
  { value: "YES", label: "Yes", label_si: "ඔව්" },
  { value: "NO", label: "No", label_si: "නැත" },
];